export interface OptionItem {
  value: string;
  label: string;
}

export interface OptionGroup {
  label: string;
  options: OptionItem[];
}

export const options: OptionGroup[] = [
	//ソート/フィルター

	// 媒体
	{
		label:'媒体',
		options:[
			{value:'illust',label:'イラスト'},
			{value:'comic',label:'漫画'},
			{value:'anime',label:'アニメーション'},
			{value:'goods',label:'販売/グッズ'},
			{value:'charaseet',label:'設定資料'},
			{value:'other',label:'その他'},
		]

	},

	//創作作品
	{
	label:'タイトル',
	options:[
			{ value:'imagia',label:'躁のイマジア'},
			{ value:'sugbt' ,label:'シュガビタエブリデイズ'},
			//{ value:'magoya',label:'魔法少女はおやすみ！'},
			//{ value:'escpsm',label:'モスコとカシス'},
		]
	},

	//キャラクター定義
	{
		label:'キャラクター',
		options:[
		//躁のイマジア
		{ value:'karoma',label:'カロマ'},
		{ value:'kafka',label:'カフカ'},
		//{ value:'aramo',label:'アラモ'}, (一旦欠番)
		//シュガビタ
		{ value:'chirol',label:'ちろる'},
		{ value:'supia',label:'すぴあ'},
		{ value:'ipuru',label:'いぷる'},
		{ value:'siruku',label:'しるく'},
		{ value:'yotuba',label:'よつば'},
		{ value:'nova',label:'プリンセス'},
		]
	},

	//タグ
	{
	label:'タグ',
	options:[
			{ value:'original',label:'オリジナル'},
			{ value:'circlecut',label:'サークルカット'},
			{ value:'fanart' ,label:'ファンアート'},
		]
	},
];


export const sortOptions = [

    { value: 'newest', label: '新しい順' },
    { value: 'oldest', label: '古い順' },
	{ value: "titleAsc", label: "名前順 (昇順)" },
	{ value: "titleDesc", label: "名前順 (降順)" },
    { value: 'popular', label: 'いいね順' },
	{ value: 'my-likes', label: '自分がいいねした順' },
	
	
];


export const getTagLabel = (value: string | undefined) => {
  if (!value) return "";
  //全てのグループの子要素（options）を1つの平らな配列にまとめる
  const allSubOptions = options.flatMap((group: OptionGroup) => group.options);
  //その平らになった名簿から、該当する value を探す
  const target = allSubOptions.find((opt: OptionItem) => opt.value === value);
  //見つかれば日本語ラベルを、なければ元の ID を返す
  return target ? target.label : value;
};